import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";

export interface DateRenderProps {
  date: string | null;
}

const emptyString = "-------";

export const DateRender = ({ date }: DateRenderProps) => {
  const theme = useTheme();
  if (date) {
    return (
      <IgTypography color={theme.palette.text.secondary}>{date}</IgTypography>
    );
  }
  return (
    <IgTypography color={theme.palette.text.secondary}>
      {emptyString}
    </IgTypography>
  );
};
